// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatausdg } from "../../../icons/full/build/icon-statausdg.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatausdgIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatausdg.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatausdgIcon.displayName = 'StatausdgIcon';
}

export default StatausdgIcon;